<script>
  import { alert } from 'vue-strap';
  import Importacao from './FormListaImportacao.vue';

  export default {
    components: { 
      alert, 
      Importacao,
    },
    props: {
      itensSolicitacaoImportacao: Array,
      relatorio: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        configuracao: this.$storage.configuracao()
      }
    },
    methods: {
      deletarItem(indice) {
        this.itensSolicitacaoImportacao.splice(indice, 1);
      }
    },
    computed: {
      total: function() {
        return this.itensSolicitacaoImportacao.reduce((somatorio, item) => {
          const valorEstimado = this.$options.filters.formatarNumero(item.valorEstimado, true);
          const quantidade = this.$options.filters.formatarNumero(item.quantidade, true);
          const desconto = this.$options.filters.formatarNumero(item.desconto, true);
          const vat = this.$options.filters.formatarNumero(item.vat, true);

          return somatorio + (((quantidade * valorEstimado) - desconto) * (1 + (vat / 100)));
        }, 0);
      }
    }
  }
</script>

<template>

  <div>
    <alert type="warning" v-if="itensSolicitacaoImportacao.length === 0">
      <i class="fa fa-warning"></i> Nenhum item adicionado.
    </alert>

    <div class="bs-callout bs-callout-info no-margin-top" v-for="(item, index) in itensSolicitacaoImportacao">
      <h4>
        Item #{{ index + 1 }}

        <button 
                type="button" 
                class="btn btn-sm btn-danger btn-delete-item"
                title="Excluir item" 
                @click="deletarItem(index)"
                v-if="!relatorio">
          <i class="fa fa-trash"></i>
        </button>
      </h4>

      <importacao
          :item="item"
          :relatorio="relatorio">
      </importacao>
    </div>

    <div class="bs-callout bs-callout-primary" v-if="configuracao.utilizarValorEstimadoImportacao">
      <h4>Valor total estimado: {{ total | formatarNumero }}</h4>
    </div>
  </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-importacao/componentes/compartilhado/FormListaItens.vue